import React from "react";
import facebook from "../assets/images/SiteImg/icon/facebook.svg";
import twitter from "../assets/images/SiteImg/icon/twitter.svg";
import address from "../assets/images/SiteImg/icon/address.svg";
import phone from "../assets/images/SiteImg/icon/phon.svg";
import email from "../assets/images/SiteImg/icon/email.svg";
import { useSelector } from "react-redux";
import {
  CONTACT_US_URL,
  FACEBOOK_URL,
  TWITTER_URL,
  buildWebsiteUrl,
} from "../config/externalUrls";
const Footer = () => {
  const user = useSelector((state) => state.user);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  return (
    <div>
      {/* <!-- footer_Wrap --> */}
      <section className="footer_top">
        <div className="theme_container">
          <div className="footer_top_inner">
            <div className="row align-items-center">
              <div className="col-lg-9">
                <h1 className="f-52">
                  Talk <span>With Us!</span>
                </h1>
                <p
                  className="f-18 f-500 mb-0"
                  style={{ textTransform: "none" }}
                >
                  We're on your side for a better financial future.
                </p>
              </div>
              <div className="col-lg-3 text-center justify-content-end d-flex">
                <a className="btn btn_brnd" href={CONTACT_US_URL}>
                  Let's Talk
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer className="footer_Wrap site-footer">
        <div className="theme_container ">
          <div className="footer_inner">
              <div className="site-footer-grid">
                <div className="site-footer-column">
                  <h2 className="site-footer-heading">Useful Links</h2>
                  <ul className="footer-lit mt-20">
                    <li>
                      <a
                        className="site-footer-link"
                        aria-current="page"
                        href={`${buildWebsiteUrl("attorneys")}${isLoggedIn && user ? "?login=true" : "?login=false"}`}
                      >
                        Attorneys
                      </a>
                    </li>
                    <li>
                      {" "}
                      <a className="site-footer-link" href={`${buildWebsiteUrl("about")}${isLoggedIn && user ? "?login=true" : "?login=false"}`}>
                        About Us
                      </a>
                    </li>
                    <li>
                      {" "}
                      <a className="site-footer-link" href={`${buildWebsiteUrl("faq")}${isLoggedIn && user ? "?login=true" : "?login=false"}`}>
                        FAQ
                      </a>
                    </li>
                    <li>
                      <a
                        className="site-footer-link"
                        href="https://www.evergreenclass.com/fee-waiver-policy?login=true"
                      >
                        Fee Waiver Policy
                      </a>
                    </li>
                    <li>
                      <a className="site-footer-link" href={`${buildWebsiteUrl("privacy-policy")}${isLoggedIn && user ? "?login=true" : "?login=false"}`}>
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a
                        className="site-footer-link"
                        href={`${buildWebsiteUrl("terms-and-condition")}${isLoggedIn && user ? "?login=true" : "?login=false"}`}
                      >
                        Terms & Condition
                      </a>
                    </li>
                  </ul>
                  <ul className="social_icon">
                    <li>
                      <a
                        href={FACEBOOK_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Evergreen on Facebook"
                      >
                        <img src={facebook} alt="facebook" />
                      </a>
                    </li>
                    <li>
                      <a
                        href={TWITTER_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Evergreen on Twitter"
                      >
                        <img src={twitter} alt="twitter" />
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="site-footer-column footer_text">
                  <h2 className="site-footer-heading">Contact Us</h2>
                  <div className="footer_contact_details mt-20">
                    <div className="footer_contact_item text-white f-16">
                      <img src={address} alt="" aria-hidden="true" />
                      <address>
                        <strong>Evergreen Financial Counseling</strong>
                        <span className="footer_contact_address">
                          1751 River Run, Suite 200, Fort Worth,
                          <br />
                          TX 76107
                        </span>
                      </address>
                    </div>
                    <div className="footer_contact_item text-white f-16">
                      <img src={email} alt="" aria-hidden="true" />
                      <a href="mailto:counselor@evergreenclass.com">
                        <strong>counselor@evergreenclass.com</strong>
                      </a>
                    </div>
                    <div className="footer_contact_item text-white f-16">
                      <img src={phone} alt="" aria-hidden="true" />
                      <a href="tel:800-581-3513">
                        <strong>800-581-3513</strong>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="site-footer-column site-footer-mission">
                  <h2 className="site-footer-heading">Evergreen's Mission</h2>
                  <p className="f-16 mt-20 text-white text-left">
                    Evergreen financial counseling seeks to empower and uplift
                    individuals through quality financial counseling and
                    education.
                  </p>
                </div>
              </div>
          </div>
          <div className="divider-line mt-12"></div>
          <p className="f16 text_dark footer-bottom mb-0">
            Rights - ©2023{" "}
            <span className="text-white">Evergreen Financial Counseling</span>.
            All rights reserved.{" "}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
